import {
    deleteUser,
    login,
    userInfo,
    validatePromotionalToken,
    validateRecoveryToken,
} from "@/api/security";
import router from "@/router";
import { logoutAndClean, setSession } from "@/utils/auth";

export default {
    state: {
        user: {},
        token: "",
        company: {},
        recoveryToken: "",
        validToken: null,
        promotionalToken: "",
        validPromotionalToken: null,
        hasSIIAutomation: false,
    },

    mutations: {
        SET_LOGIN: (state, payload) => {
            state.user = payload.user;
            state.token = payload.token;
            state.company = payload.user.companies[0];
        },
        SET_USER_INFO: (state, payload) => {
            state.user = payload;
        },
        SET_RECOVERY_TOKEN: (state, payload) => {
            state.recoveryToken = payload;
        },
        SET_PROMOTIONAL_TOKEN: (state, payload) => {
            state.promotionalToken = payload;
        },
        SET_SII_AUTOMATION: (state, payload) => {
            state.hasSIIAutomation = payload;
        },
        SET_VALID_TOKEN: (state, payload) => {
            state.validToken = payload;
        },
        SET_VALID_PROMOTIONAL_TOKEN: (state, payload) => {
            state.validPromotionalToken = payload;
        },
        CLEAR_USER: (state) => {
            state.user = "";
            state.token = "";
            state.company = "";
        },
    },

    actions: {
        loginByUserInfo({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo.username, userInfo.password)
                    .then((response) => {
                        const data = response.data;
                        setSession(data);
                        commit("SET_LOGIN", data);
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        setLoginInfo({ commit }, loginInfo) {
            commit("SET_LOGIN", loginInfo);
            if (loginInfo.user.companies[0]?.company_product_link_sii) {
                commit("SET_SII_AUTOMATION", true);
            } else {
                commit("SET_SII_AUTOMATION", false);
            }
        },
        getUserInfo({ commit }, email) {
            new Promise((resolve, reject) => {
                userInfo({ email })
                    .then((response) => {
                        const data = response.data;
                        commit("SET_USER_INFO", data);
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async clearUserInfo({ commit }) {
            try {
                await logoutAndClean();
            } finally {
                commit("CLEAR_USER");
                router.push("/");
            }
        },
        validateRecoveryToken({ commit }, token) {
            return new Promise((resolve, reject) => {
                validateRecoveryToken(token)
                    .then(() => {
                        commit("SET_VALID_TOKEN", true);
                        resolve(true);
                    })
                    .catch(() => {
                        commit("SET_VALID_TOKEN", false);
                        reject(false);
                    });
            });
        },
        callValidatePromotionalToken({ commit }, token) {
            return new Promise((resolve, reject) => {
                validatePromotionalToken(token)
                    .then(() => {
                        commit("SET_VALID_PROMOTIONAL_TOKEN", true);
                        resolve(true);
                    })
                    .catch(() => {
                        commit("SET_VALID_PROMOTIONAL_TOKEN", false);
                        reject(false);
                    });
            });
        },
        async deleteSelf({ commit }) {
            try {
                await deleteUser();
                await logoutAndClean();
            } finally {
                commit("CLEAR_USER");
                router.push("/");
            }
        },
    },
    namespaced: true,
};
